export default "__VITE_ASSET__CelI5H0X__"